import { Link } from 'react-router-dom';
import { PageShell } from '@/components/site/PageShell';
import { Seo } from '@/components/seo/Seo';
import { Button } from '@/components/ui/button';

export default function NotFoundPage() {
  return (
    <PageShell testId="not-found-page">
      <Seo title="Page not found" noindex />
      <section className="max-w-3xl mx-auto px-6 py-32">
        <p className="font-mono text-sm text-[#0047FF]">404</p>
        <h1 className="mt-3 font-heading text-4xl sm:text-5xl font-bold tracking-tight text-[#09090B]" data-testid="page-title">This square is empty.</h1>
        <p className="mt-4 text-[#71717A]">The page you were looking for doesn&apos;t exist or has moved.</p>
        <div className="mt-8 flex gap-3">
          <Button asChild className="bg-[#0047FF] hover:bg-[#0037CC] text-white" data-testid="not-found-home"><Link to="/">Back to home</Link></Button>
          <Button asChild variant="outline" className="border-[#E4E4E7]"><Link to="/guides">Read the guides</Link></Button>
        </div>
      </section>
    </PageShell>
  );
}
